<template lang="pug">
  self-layout
    template(#subheader)
      self-subheader
    template(#input)
      self-input
</template>

<script>
import SelfLayout from './layout/'
import SelfSubheader from './subheader/'
import SelfInput from './input/'

export default {
  components: {
    SelfLayout,
    SelfSubheader,
    SelfInput
  }
}
</script>
